import type { Client, RequestContext } from "../client";
import type { RunbookProcessResource, RunbookSnapshotTemplateResource } from "../resources";
import { BasicRepository } from "./basicRepository";
export class RunbookProcessRepository extends BasicRepository<RunbookProcessResource, RunbookProcessResource> {
    constructor(client: Client, requestContext: RequestContext) {
        super("RunbookProcesses", client, requestContext);
    }
    getRunbookSnapshotTemplate(runbookProcess: RunbookProcessResource, runbookSnapshotId: string) {
        return this.client.get<RunbookSnapshotTemplateResource>(this.requestContext, runbookProcess.Links["RunbookSnapshotTemplate"], { runbookSnapshotId });
    }
    get(processId: string) {
        return this.client.get<RunbookProcessResource>(this.requestContext, `~/api/spaces/{spaceId}/runbookprocesses/{processId}`, {
            processId,
        });
    }
}
